(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nse-our-legacy"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('nse-legacy-page')) {
    customElements.define(
      'nse-legacy-page',
      class extends HTMLElement {
        connectedCallback() {
          this._frame = requestAnimationFrame(() => this.init());
        }
        disconnectedCallback() {
          cancelAnimationFrame(this._frame);
          this._events?.abort();
          this._resize?.disconnect();
        }
        init() {
          this._events?.abort();
          this._resize?.disconnect();
          this._events = new AbortController();
          const signal = this._events.signal;
          const on = (node, event, callback) => node?.addEventListener(event, callback, { signal });
          const viewport = this.querySelector('[data-slider-viewport]');
          const track = this.querySelector('[data-slider-track]');
          const slides = Array.from(this.querySelectorAll('.recognition-card'));
          const previous = this.querySelector('[data-slider-prev]');
          const next = this.querySelector('[data-slider-next]');
          const status = this.querySelector('[data-slider-status]');
          const footer = this.querySelector('[data-slider-footer]');
          let index = 0;
          let pointerStart = null;
          let renderSlider = () => {};
          if (viewport && track && slides.length && previous && next && status) {
            renderSlider = () => {
              const visible = Math.min(
                slides.length,
                parseInt(getComputedStyle(track).getPropertyValue('--visible'), 10) || 1
              );
              const max = Math.max(0, slides.length - visible);
              index = Math.max(0, Math.min(index, max));
              const width = slides[0].getBoundingClientRect().width;
              const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
              track.style.transform = `translateX(${-index * (width + gap)}px)`;
              previous.disabled = index === 0;
              next.disabled = index === max;
              footer.hidden = slides.length <= visible;
              status.textContent =
                visible === 1
                  ? `Showing ${index + 1} of ${slides.length}`
                  : `Showing ${index + 1}–${Math.min(index + visible, slides.length)} of ${slides.length}`;
              slides.forEach((slide, position) => {
                const hidden = position < index || position >= index + visible;
                slide.setAttribute('aria-hidden', String(hidden));
                slide.inert = hidden;
              });
            };
            const move = (delta) => {
              index += delta;
              renderSlider();
            };
            on(previous, 'click', () => move(-1));
            on(next, 'click', () => move(1));
            on(this.querySelector('.recognition-carousel'), 'keydown', (event) => {
              if (event.key === 'ArrowRight') {
                event.preventDefault();
                move(1);
              }
              if (event.key === 'ArrowLeft') {
                event.preventDefault();
                move(-1);
              }
              if (event.key === 'Home') {
                event.preventDefault();
                index = 0;
                renderSlider();
              }
              if (event.key === 'End') {
                event.preventDefault();
                index = slides.length;
                renderSlider();
              }
            });
            on(viewport, 'pointerdown', (event) => {
              if (event.pointerType !== 'mouse') pointerStart = { x: event.clientX, y: event.clientY };
            });
            on(viewport, 'pointerup', (event) => {
              if (!pointerStart) return;
              const dx = event.clientX - pointerStart.x;
              const dy = event.clientY - pointerStart.y;
              if (Math.abs(dx) > 38 && Math.abs(dx) > Math.abs(dy)) move(dx < 0 ? 1 : -1);
              pointerStart = null;
            });
            on(viewport, 'pointercancel', () => {
              pointerStart = null;
            });
            if ('ResizeObserver' in window) {
              this._resize = new ResizeObserver(renderSlider);
              this._resize.observe(viewport);
            } else on(window, 'resize', renderSlider);
          }

          const tabs = Array.from(this.querySelectorAll('[data-location-tab]'));
          const panels = Array.from(this.querySelectorAll('[data-location-panel]'));
          const tablist = this.querySelector('[data-location-tabs]');
          const locationStatus = this.querySelector('[data-location-status]');
          const selectLocation = (tab, focus = false, announce = true) => {
            if (!tab) return;
            tabs.forEach((item) => {
              const active = item === tab;
              item.setAttribute('aria-selected', String(active));
              item.tabIndex = active ? 0 : -1;
            });
            panels.forEach((panel) => {
              const active = panel.dataset.locationPanel === tab.dataset.locationTab;
              panel.hidden = !active;
              panel.setAttribute('role', 'tabpanel');
              const label = tabs.find((item) => item.dataset.locationTab === panel.dataset.locationPanel);
              if (label) panel.setAttribute('aria-labelledby', label.id);
              if (active && announce && locationStatus)
                locationStatus.textContent = `${tab.textContent.trim()} selected.`;
            });
            if (focus) tab.focus();
          };
          tabs.forEach((tab, position) => {
            on(tab, 'click', () => selectLocation(tab));
            on(tab, 'keydown', (event) => {
              let destination;
              if (event.key === 'ArrowRight') destination = (position + 1) % tabs.length;
              if (event.key === 'ArrowLeft') destination = (position - 1 + tabs.length) % tabs.length;
              if (event.key === 'Home') destination = 0;
              if (event.key === 'End') destination = tabs.length - 1;
              if (destination !== undefined) {
                event.preventDefault();
                selectLocation(tabs[destination], true);
              }
            });
          });
          if (tablist) tablist.hidden = tabs.length < 2;
          selectLocation(tabs[0], false, false);
          this.classList.add('is-enhanced');
          renderSlider();

          // Theme Editor selections reveal the corresponding award or location.
          on(this, 'shopify:block:select', (event) => {
            const blockId = event.detail?.blockId;
            const slideIndex = slides.findIndex((slide) => slide.dataset.blockId === blockId);
            if (slideIndex !== -1) {
              index = slideIndex;
              renderSlider();
              viewport?.scrollIntoView({ block: 'center', behavior: 'auto' });
            }
            const tab = tabs.find((item) => item.dataset.locationTab === blockId);
            if (tab) {
              selectLocation(tab, false);
              panels
                .find((panel) => panel.dataset.locationPanel === blockId)
                ?.scrollIntoView({ block: 'center', behavior: 'auto' });
            }
          });
          // Local anchors respect the merchant's sticky-header offset.
          on(this, 'click', (event) => {
            const link = event.target.closest('a[href^="#Legacy"]');
            if (!link || !this.contains(link)) return;
            const target = document.getElementById(link.getAttribute('href').slice(1));
            if (!target || !this.contains(target)) return;
            event.preventDefault();
            target.scrollIntoView({
              block: 'start',
              behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            });
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
